/* tslint:disable */
/* eslint-disable */
/**
 * Contract Management API
 * API for managing contracts
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GroupContractItemDto } from './GroupContractItemDto';
import {
    GroupContractItemDtoFromJSON,
    GroupContractItemDtoFromJSONTyped,
    GroupContractItemDtoToJSON,
    GroupContractItemDtoToJSONTyped,
} from './GroupContractItemDto';

/**
 * 
 * @export
 * @interface GetGroupContractListResponse
 */
export interface GetGroupContractListResponse {
    /**
     * 
     * @type {number}
     * @memberof GetGroupContractListResponse
     */
    totalCount: number;
    /**
     * 
     * @type {Array<GroupContractItemDto>}
     * @memberof GetGroupContractListResponse
     */
    items: Array<GroupContractItemDto>;
}

/**
 * Check if a given object implements the GetGroupContractListResponse interface.
 */
export function instanceOfGetGroupContractListResponse(value: object): value is GetGroupContractListResponse {
    if (!('totalCount' in value) || value['totalCount'] === undefined) return false;
    if (!('items' in value) || value['items'] === undefined) return false;
    return true;
}

export function GetGroupContractListResponseFromJSON(json: any): GetGroupContractListResponse {
    return GetGroupContractListResponseFromJSONTyped(json, false);
}

export function GetGroupContractListResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetGroupContractListResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'totalCount': json['totalCount'],
        'items': ((json['items'] as Array<any>).map(GroupContractItemDtoFromJSON)),
    };
}

export function GetGroupContractListResponseToJSON(json: any): GetGroupContractListResponse {
    return GetGroupContractListResponseToJSONTyped(json, false);
}

export function GetGroupContractListResponseToJSONTyped(value?: GetGroupContractListResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'totalCount': value['totalCount'],
        'items': ((value['items'] as Array<any>).map(GroupContractItemDtoToJSON)),
    };
}

